import React from 'react';
import './whatsapp.css';

const WhatsApp = () => {
  const phoneNumber = "919810044015"; 
  const message = "Hello! I am interested in the IHN  events.";
  
  // URL encode the message for the link
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl} 
      className="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
        alt="WhatsApp" 
      />

    </a>
  );
};

export default WhatsApp;



// import { useEffect } from "react";

// const TawkChat = () => {
//   useEffect(() => {
//     var Tawk_API = Tawk_API || {};
//     var Tawk_LoadStart = new Date();

//     (function () {
//       var s1 = document.createElement("script");
//       var s0 = document.getElementsByTagName("script")[0];
//       s1.async = true;
//       s1.src = "https://embed.tawk.to/698d7ab00867ad1c391802f4/1jh8aegur";
//       s1.charset = "UTF-8";
//       s1.setAttribute("crossorigin", "*");
//       s0.parentNode.insertBefore(s1, s0);
//     })();
//   }, []);

//   return null;
// };

// export default TawkChat;